module.exports = __webpack_public_path__ + "img/logo.8465a17c.png";